import { inject, Injectable, signal } from '@angular/core';
import { StorageService } from './storage.service';
import Swal from 'sweetalert2';

const USER_DETAILS_KEY = 'user-details';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private readonly storageService = inject(StorageService);
  readonly userDetails = signal<any>(this.storageService.get<any>(USER_DETAILS_KEY) ?? '');
  emptyTokenErrorShown: boolean = false;
  setUserDetails(user: any): void {
    this.userDetails.set(user ?? '');
    if (user) {
      this.storageService.set(USER_DETAILS_KEY, user);
    } else {
      this.storageService.remove(USER_DETAILS_KEY);
    }
  }
  emailPattern = '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';
  namePattern = /^[a-zA-Z\s'",-]+$/;
  passwordPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,20}$/;
  taxIdPattern = '^\\d{2}-?\\d{7}$';
  cliaPattern = '^[A-Za-z0-9]{10}$';
  cliaPatternNew = '^[A-Z]{2}\\d{10}$';
  addressPattern = "^[A-Za-z0-9'\\.\\-\\s\\,]*$";
  phonePattern = '^(\\(?\\d{3}\\)?[\\s\\-]?)\\d{3}[\\s\\-]?\\d{4}$';
  ssnPattern = '^\\d{3}-\\d{2}-\\d{4}$';
  upinPattern = '^[a-zA-Z0-9]{6}$';
  feePattern = '^(?!^0*$)(?!^0*\\.0*$)^\\d{0,10}(\\.\\d{1,2})?$';
  zipCodePattern = '^[0-9]{5}(?:[0-9]{4})?$';
  CityPattern = /^[A-Za-z]+(?:[ .'-][A-Za-z]+)*$/;
  CityPattern1 = /^[A-Za-z0-9]+(?:[ .,:\/\-&'()"*][A-Za-z0-9]+)*$/;
  CityPattern2 = /^(?=.{1,35}$)(?![^\w\d]*$)[A-Za-z0-9](?:[A-Za-z0-9 :.,\-\/&'()""*—]*[A-Za-z0-9])?$/;
  State = /^[A-Za-z]{2}$/;
  numbersPattern = '^[0-9]*$';
  stringWithNumberAndSpacePattern = '[a-zA-Z0-9 ]*$';
  stringWithSpacePattern = '/^[a-zA-Z ]*$/';
  nameWithSpacePattern = '^[a-zA-Z ]*$';
  nameWithSpacePattern1 = '^[a-zA-Z \\n]*$';
  stringPattern = '^[a-zA-Z]*$';
  alphanumericWithoutSpacePattern = '[a-z0-9]+([a-z0-9]+)*$';
  alphanumericWithoutSpacePattern1 = '[a-zA-Z0-9]+([a-zA-Z0-9]+)*$';
  alphanumericWithSpaceAtMiddlePattern = '^[a-zA-Z0-9]+([ ][a-zA-Z0-9]+)*$';
  stringWithSpaceAtmiddlePattern = '^[a-zA-Z]+([ ][a-zA-Z]+)*$';
  descriptionPattern = "^[A-Za-z0-9'\\.\\-\\s\\,]*$";
  physicianSignaturePattern = "^[A-Za-z0-9'\\.\\-\\s\\,\\{\\}]*$";
  icdCodePattern = '[A-TV-Z][0-9][0-9AB].?[0-9A-TV-Z]{0,4}';
  diagnosisCodePattern = '^[A-Z0-9.]*$';
  diagnosisCode = '^[A-Z0-9]+(.[A-Z0-9]+)*$';
  diagnosisCode2 = '^[A-Z][A-Z0-9]+(.[A-Z0-9]+)*$';
  NDCCodePattern = '^\\d{5}-\\d{4}-\\d{2}$';
  npiPattern = '[0-9]{10}';
  numbersAndStringPattern = '[a-zA-Z0-9]*$';
  alphaNumericPattern = /^[a-zA-Z0-9]*$/;
  alphaNumericWithSpacePattern = /^[a-zA-Z0-9\s]*$/;
  alphaNumericWithSpacePattern1 = /^[a-zA-Z0-9\s ]*$/;
  alphaNumericWithSpaceComaPattern = /^[a-zA-Z0-9,\s]+$/;
  alphaNumericWithSpaceSplPattern = /^[A-Za-z0-9\s_.&+-]*$/;
  alphaNumericWithSpaceComaDotPattern = /^[a-zA-Z0-9,\s.]*$/;
  alphaNumericWithHyphen = /^[a-zA-Z0-9-_]+$/;
  alphaNumericSpecialCharacterPattern = /^[a-zA-Z0-9\s!$%&<>,.;:'|()]*$/;
  descriptionSpecialCharacterPattern = /^[A-Za-z0-9 .,:\-/&'()"*]+$/;
  cptCodePattern = '^[A-Za-z0-9]{3,5}$';
  cptModdifierPattern = '^([a-zA-Z0-9]){2}$';
  decimalNumberPatter = '^(\\d{1,5})\\.\\d{1,4}$';
  decimalNumberPattern1 = '^(\\d{1,16})(\\.\\d{1,15})?$';
  checkNumberPattern = /^[a-zA-Z0-9!@#$%&()\[\]{}\-+=;:'",.<>/?`\\]+$/;

  atleastOneDecimal = '^(?:0|[1-9]d+|)?(?:.?d{0,2})?$';
  PTAN = '[0-9]{6}';
  tinPattern = '^\\d{3}-\\d{2}-\\d{4}$';
  medicaidNumber = '[0-9]{9}';
  copay = '[0-9]{2}';
  percentageRegex = /^(100|[1-9][0-9]?)%$/;
  numberPattern = '^[0-9]{1,11}(?:.[0-9]{1,3})?$';
  numberPattern1 = '^[0-9]+(\.[0-9]{1,2})?$';
  nonZero = '^(?!(0))[0-9]+$';
  feePercentPattern = /^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?)$/;
  zipCodeNew = '^\\d{5}(-\\d{4})?$';
  urlPattern =
    '^(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$';

  specialCharactersPattern =
    /^(?:([$&+,:;=?@#|'<>.^*()%!-])(?!.*?\1),)*[$&+,:;=?@#|'<>.^*()%!-]$/;
  showAlert(
    title: any,
    msg: any,
    btnTxt: any,
    icon: any,
    showCancel: any = true,
    btnCancelTxt: any = 'No'
  ) {
    const popStateHandler = () => {
      Swal.close();
    };

    // Attach event listener
    window.addEventListener('popstate', popStateHandler);
    return Swal.fire({
      title: title,
      text: msg,
      icon: icon,
      reverseButtons: false,
      showCancelButton: showCancel,
      confirmButtonColor: '#c91d1de6',
      cancelButtonColor: '',
      confirmButtonText: btnTxt,
      cancelButtonText: btnCancelTxt,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }
  onKeyPressWithDecimal(event: any): void {
    const charCode = event.which ? event.which : event.keyCode;
     const input = event.target as HTMLInputElement;
  const value = input.value;
    // Allow only numbers (0-9) and one decimal point
    if (
      charCode > 31 &&
      (charCode < 48 || charCode > 57) && // Not a digit
      charCode !== 46 // Not a dot (.)
    ) {
      event.preventDefault();
    }

    // Prevent multiple decimal points
    if (charCode === 46 && value.includes('.')) {
      event.preventDefault();
    }

     const decimalIndex = value.indexOf('.');
  if (decimalIndex !== -1) {
    const cursorPos = input.selectionStart ?? value.length;

    // If cursor is after decimal and already 2 digits exist
    if (
      cursorPos > decimalIndex &&
      value.substring(decimalIndex + 1).length >= 2
    ) {
      event.preventDefault();
    }
  }
  }
}
